import MenuSmartSegmentation from "../MenuSmartSegmentation";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuIniciRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function SegmentacaoClientes() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/smart-segmentation">Smart Segmentation</a>
                  </li>
                  <li className="breadcrumb-item active">
                    O que é a Segmentação de Clientes?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuSmartSegmentation />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                O que é a Segmentação de Clientes?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Smart Segmentation</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Segmentação de dados
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  A segmentação de dados é uma prática essencial para empresas
                  que desejam entender profundamente seu público-alvo e otimizar
                  suas estratégias de marketing e vendas. Quando uma base de
                  dados é segmentada com informações socioeconômicas,
                  psicográficas e classificações de negócios do cliente, as
                  vantagens podem ser impactantes.
                </p>

                <p>
                  Segmentar dados com informações socioeconômicas, psicográficas
                  e de classificação de negócios permite uma visão holística do
                  cliente. As informações socioeconômicas, como idade, renda e
                  localização, fornecem uma base sólida, enquanto as informações
                  psicográficas revelam motivações, interesses e comportamentos.
                </p>

                <p>
                  Com dados segmentados dessa maneira, as empresas podem criar
                  campanhas de marketing altamente personalizadas.
                </p>

                <p>
                  Outro benefício ao entender os hábitos de compra e as
                  preferências psicográficas, as empresas podem sugerir produtos
                  ou serviços que atendam às necessidades específicas de cada
                  cliente. Isso resulta em uma experiência mais satisfatória e,
                  consequentemente, em uma maior fidelização. <a> </a>
                  <a
                    href="/como-criar-uma-segmentacao-de-clientes"
                    target="blank"
                  >
                    Entenda aqui
                  </a>
                  <a> </a>como criar uma segmentação de clientes.
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuIniciRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
